export default __webpack_public_path__ + "static/media/etherscan.58bf9e1c.svg";